import React from 'react';
import { Flex, Text } from '@chakra-ui/react';

const Footer = () => {
  return (
    <Flex
      as="footer"
      bg="surface"
      color="textMuted"
      borderTop="1px solid"
      borderColor="borderPrimary"
      w="100%"
      py="2"
      justify="center"
      align="center"
    >
      <Text fontSize="xs">© {new Date().getFullYear()} Nogle Tech. Todos os direitos reservados.</Text>
    </Flex>
  );
};

export default Footer;
